import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['../../General/tiles.css','./login.component.css']
})
export class LoginComponent{
  
  public language: string;
  public name: string;
  public classid: string;

  showConfigTip: boolean = true;
  showStateTip: boolean = true;

  constructor(public appService: AppService, protected http: HttpClient) { 
    this.language = this.appService.languageAbbreviation;
  }
  
  /** get text in right language 
  * @param {string} tag - text to load
  */
  get(tag:string): String {
	return this.appService.get(tag);
  }
  
  /** load the configuration */
  loadConfig($event): void {
    this.appService.loadConfig($event.target);
  }
  
  /** load the state */
  loadState($event) : void {
    this.appService.loadState($event.target);
  }

  /** load the state */
  storeConfig() : void {
    this.appService.storeConfigTeacher();
  }

  /** store the configuration for student */
  storeConfigStudent(): void {
    this.appService.storeConfigStudent();
  }

  /** load the state */
  storeState() : void {
    this.appService.storeState();
  }

  /** changes the language */
  onChangeLanguage(){
    this.appService.changeLanguage(this.language);
  }

  /** load a predefined configuration --> typically not visible, can be used for demonstrations */
  loadConfigEmergency(): void {
    let self = this;
    let filename: string = "./assets/"+this.language+"_book_config.json";

    /* ### DEMO ###
    this line is used for the demo. Uncomment it if you build a demo version
    
    filename = "./assets/"+this.language+"_book_config_teacher.json";*/

    this.http.get(filename).subscribe(result => {
      self.appService.configuration = result;
      self.appService.onLoadedConfig();
    });
  }

}
